const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.StallApplicationServiceSimpleClient =
  function StallApplicationServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.listStallApplications = this.listStallApplications.bind(this);
    this.getStallApplication = this.getStallApplication.bind(this);
    this.deleteStallApplication = this.deleteStallApplication.bind(this);
    this.updateStallApplication = this.updateStallApplication.bind(this);
    this.createStallApplication = this.createStallApplication.bind(this);
    this.submitStallApplication = this.submitStallApplication.bind(this);
    this.withdrawStallApplication = this.withdrawStallApplication.bind(this);
    this.completeStallApplication = this.completeStallApplication.bind(this);
    this.saveDraftStallApplication = this.saveDraftStallApplication.bind(this);
    this.listStableEntries = this.listStableEntries.bind(this);
    this.getStableEntry = this.getStableEntry.bind(this);
    this.deleteStableEntry = this.deleteStableEntry.bind(this);
    this.updateStableEntry = this.updateStableEntry.bind(this);
    this.createStableEntry = this.createStableEntry.bind(this);
    this.getStallApplicationForm = this.getStallApplicationForm.bind(this);
    this.deleteStallApplicationForm =
      this.deleteStallApplicationForm.bind(this);
    this.updateStallApplicationForm =
      this.updateStallApplicationForm.bind(this);
    this.createStallApplicationForm =
      this.createStallApplicationForm.bind(this);
    this.listStallApplicationForms = this.listStallApplicationForms.bind(this);
    this.setFacilityOptions = this.setFacilityOptions.bind(this);
    this.setFacilityPreferences = this.setFacilityPreferences.bind(this);
    this.pullStallApplicationFormTermsFileSignedUrl =
      this.pullStallApplicationFormTermsFileSignedUrl.bind(this);
    this.pullStallApplicationFormSummary =
      this.pullStallApplicationFormSummary.bind(this);
  };
const methodInfo_StallApplicationService_ListStallApplications =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplications",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListStallApplicationsRequest,
    imports.stronachgroup.first.racehorse360.ListStallApplicationsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListStallApplicationsResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.listStallApplications =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListStallApplicationsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplications",
      message,
      metadata || {},
      methodInfo_StallApplicationService_ListStallApplications
    );
  };
const methodInfo_StallApplicationService_GetStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplication",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetStallApplicationRequest,
    imports.stronachgroup.first.racehorse360.StallApplication,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StallApplication.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.getStallApplication =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetStallApplicationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplication",
      message,
      metadata || {},
      methodInfo_StallApplicationService_GetStallApplication
    );
  };
const methodInfo_StallApplicationService_DeleteStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplication",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteStallApplicationRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.deleteStallApplication =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteStallApplicationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplication",
      message,
      metadata || {},
      methodInfo_StallApplicationService_DeleteStallApplication
    );
  };
const methodInfo_StallApplicationService_UpdateStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplication",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UpdateStallApplicationRequest,
    imports.stronachgroup.first.racehorse360.StallApplication,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StallApplication.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.updateStallApplication =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UpdateStallApplicationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplication",
      message,
      metadata || {},
      methodInfo_StallApplicationService_UpdateStallApplication
    );
  };
const methodInfo_StallApplicationService_CreateStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplication",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateStallApplicationRequest,
    imports.stronachgroup.first.racehorse360.StallApplication,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StallApplication.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.createStallApplication =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateStallApplicationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplication",
      message,
      metadata || {},
      methodInfo_StallApplicationService_CreateStallApplication
    );
  };
const methodInfo_StallApplicationService_SubmitStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/SubmitStallApplication",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SubmitStallApplicationRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.submitStallApplication =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SubmitStallApplicationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SubmitStallApplication",
      message,
      metadata || {},
      methodInfo_StallApplicationService_SubmitStallApplication
    );
  };
const methodInfo_StallApplicationService_WithdrawStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/WithdrawStallApplication",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.WithdrawStallApplicationRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.withdrawStallApplication =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.WithdrawStallApplicationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/WithdrawStallApplication",
      message,
      metadata || {},
      methodInfo_StallApplicationService_WithdrawStallApplication
    );
  };
const methodInfo_StallApplicationService_CompleteStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/CompleteStallApplication",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CompleteStallApplicationRequest,
    imports.stronachgroup.first.racehorse360.StallApplication,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StallApplication.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.completeStallApplication =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CompleteStallApplicationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CompleteStallApplication",
      message,
      metadata || {},
      methodInfo_StallApplicationService_CompleteStallApplication
    );
  };
const methodInfo_StallApplicationService_SaveDraftStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/SaveDraftStallApplication",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest,
    imports.stronachgroup.first.racehorse360.StallApplication,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StallApplication.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.saveDraftStallApplication =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SaveDraftStallApplication",
      message,
      metadata || {},
      methodInfo_StallApplicationService_SaveDraftStallApplication
    );
  };
const methodInfo_StallApplicationService_ListStableEntries =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/ListStableEntries",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListStableEntriesRequest,
    imports.stronachgroup.first.racehorse360.ListStableEntriesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListStableEntriesResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.listStableEntries =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListStableEntriesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStableEntries",
      message,
      metadata || {},
      methodInfo_StallApplicationService_ListStableEntries
    );
  };
const methodInfo_StallApplicationService_GetStableEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/GetStableEntry",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetStableEntryRequest,
    imports.stronachgroup.first.racehorse360.StableEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StableEntry.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.getStableEntry =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetStableEntryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStableEntry",
      message,
      metadata || {},
      methodInfo_StallApplicationService_GetStableEntry
    );
  };
const methodInfo_StallApplicationService_DeleteStableEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStableEntry",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteStableEntryRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.deleteStableEntry =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteStableEntryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStableEntry",
      message,
      metadata || {},
      methodInfo_StallApplicationService_DeleteStableEntry
    );
  };
const methodInfo_StallApplicationService_UpdateStableEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStableEntry",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UpdateStableEntryRequest,
    imports.stronachgroup.first.racehorse360.StableEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StableEntry.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.updateStableEntry =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UpdateStableEntryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStableEntry",
      message,
      metadata || {},
      methodInfo_StallApplicationService_UpdateStableEntry
    );
  };
const methodInfo_StallApplicationService_CreateStableEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/CreateStableEntry",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateStableEntryRequest,
    imports.stronachgroup.first.racehorse360.StableEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StableEntry.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.createStableEntry =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateStableEntryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStableEntry",
      message,
      metadata || {},
      methodInfo_StallApplicationService_CreateStableEntry
    );
  };
const methodInfo_StallApplicationService_GetStallApplicationForm =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplicationForm",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetStallApplicationFormRequest,
    imports.stronachgroup.first.racehorse360.StallApplicationForm,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StallApplicationForm.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.getStallApplicationForm =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetStallApplicationFormRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplicationForm",
      message,
      metadata || {},
      methodInfo_StallApplicationService_GetStallApplicationForm
    );
  };
const methodInfo_StallApplicationService_DeleteStallApplicationForm =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplicationForm",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.deleteStallApplicationForm =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplicationForm",
      message,
      metadata || {},
      methodInfo_StallApplicationService_DeleteStallApplicationForm
    );
  };
const methodInfo_StallApplicationService_UpdateStallApplicationForm =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplicationForm",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest,
    imports.stronachgroup.first.racehorse360.StallApplicationForm,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StallApplicationForm.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.updateStallApplicationForm =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplicationForm",
      message,
      metadata || {},
      methodInfo_StallApplicationService_UpdateStallApplicationForm
    );
  };
const methodInfo_StallApplicationService_CreateStallApplicationForm =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplicationForm",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateStallApplicationFormRequest,
    imports.stronachgroup.first.racehorse360.StallApplicationForm,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.StallApplicationForm.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.createStallApplicationForm =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateStallApplicationFormRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplicationForm",
      message,
      metadata || {},
      methodInfo_StallApplicationService_CreateStallApplicationForm
    );
  };
const methodInfo_StallApplicationService_ListStallApplicationForms =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplicationForms",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListStallApplicationFormsRequest,
    imports.stronachgroup.first.racehorse360.ListStallApplicationFormsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListStallApplicationFormsResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.listStallApplicationForms =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListStallApplicationFormsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplicationForms",
      message,
      metadata || {},
      methodInfo_StallApplicationService_ListStallApplicationForms
    );
  };
const methodInfo_StallApplicationService_SetFacilityOptions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityOptions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetFacilityOptionsRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.setFacilityOptions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetFacilityOptionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityOptions",
      message,
      metadata || {},
      methodInfo_StallApplicationService_SetFacilityOptions
    );
  };
const methodInfo_StallApplicationService_SetFacilityPreferences =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityPreferences",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetFacilityPreferencesRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.setFacilityPreferences =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetFacilityPreferencesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityPreferences",
      message,
      metadata || {},
      methodInfo_StallApplicationService_SetFacilityPreferences
    );
  };
const methodInfo_StallApplicationService_PullStallApplicationFormTermsFileSignedUrl =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormTermsFileSignedUrl",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest,
    imports.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.pullStallApplicationFormTermsFileSignedUrl =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormTermsFileSignedUrl",
      message,
      metadata || {},
      methodInfo_StallApplicationService_PullStallApplicationFormTermsFileSignedUrl
    );
  };
const methodInfo_StallApplicationService_PullStallApplicationFormSummary =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormSummary",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest,
    imports.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse.decode
  );
module.exports.StallApplicationServiceSimpleClient.prototype.pullStallApplicationFormSummary =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormSummary",
      message,
      metadata || {},
      methodInfo_StallApplicationService_PullStallApplicationFormSummary
    );
  };
